const article = {
    slug: "first_pleats_please_issey_miyake_experience",
    category: "BRAND ENTRY",
    title: "PLEATS PLEASE ISSEY MIYAKEをレンタル体験",
    listDescription:
      "三宅一生の思想と技術が、日常で最も体験しやすい形になったPLEATS PLEASEを知る入口ページ。",
    seo: {
      title:
        "PLEATS PLEASE ISSEY MIYAKEとは｜三宅一生のプリーツ技術とレンタル体験",
      description:
        "PLEATS PLEASE ISSEY MIYAKEが気になる方へ。三宅一生の生い立ち、デザイン思想、なぜこのラインが生まれたのか、製品プリーツの技術、日常で着る意味を解説し、Enclopediaでレンタル・会員登録・買取相談へ案内します。",
      keyword:
        "PLEATS PLEASE ISSEY MIYAKE,プリーツプリーズ,プリーツプリーズとは,PLEATS PLEASEとは,プリーツプリーズ イッセイミヤケ,三宅一生 プリーツ,イッセイミヤケ プリーツ,ISSEY MIYAKE プリーツ,プリーツプリーズ 技術,製品プリーツ,プリーツプリーズ 歴史,プリーツプリーズ 名作,プリーツプリーズ レンタル,PLEATS PLEASE レンタル,プリーツプリーズ 買取,PLEATS PLEASE 買取,ISSEY MIYAKE 買取,イッセイミヤケ 買取,enclopedia,アンクロペディア",
      canonicalPath: "/archive_guide/first_pleats_please_issey_miyake_experience",
    },
    hero: {
      label: "PLEATS PLEASE ISSEY MIYAKE EXPERIENCE",
      number: "02 / ENTRY",
      titleLines: ["PLEATS PLEASEを、", "着ることで理解する。"],
      body:
        "PLEATS PLEASE ISSEY MIYAKEは、ただのプリーツ服ではありません。\n三宅一生が考え続けた“多くの人のための服”が、技術、身体、日常、自由を通して形になったラインです。\n\n軽く、動きやすく、水洗いでき、身体に合わせて伸び縮みする。\nその機能性の奥には、服を一部の人だけのものにしないという思想があります。\n\nこのページでは、三宅一生の生い立ちと思想、プリーツ技術、PLEATS PLEASEが生まれた理由を整理しながら、Enclopediaで体験できるISSEY MIYAKEのアーカイブへつなげます。",
      keywords: [
        "pleats please",
        "issey miyake",
        "garment pleating",
        "wearable design",
      ],
      visualLabel: "ARCHIVE EXPERIENCE",
      visualTitle: ["プリーツは、", "身体を自由にする技術。"],
      image: "media/archive_fashion/archive_guide12.png",
      imageAlt:
        "PLEATS PLEASE ISSEY MIYAKEをレンタル体験するためのアーカイブガイド画像",
      ctaLabel: "レンタルできるPLEATS PLEASE ISSEY MIYAKEを見る",
      ctaHref:
        "https://www.enclopedia-official.com/brand/PLEATS%20PLEASE（プリーツプリーズ）/?number=94",
    },
    thesis: {
      text:
        "PLEATS PLEASEは、装飾としてのプリーツではなく、身体・生活・移動・洗濯・保管まで含めて服を自由にするための技術です。",
      keywords: ["pleats", "technology", "freedom"],
    },
    sections: {
      whyThisPage: {
        label: "02 / WHY THIS PAGE?",
        titleLines: [
          "プリーツプリーズは、",
          "なぜ長く評価され続けるのか。",
        ],
        body:
          "PLEATS PLEASE ISSEY MIYAKEは、ファッション好きだけのための服ではありません。\n軽い、洗える、しわを気にしなくていい、身体に沿う、動きやすい。\n日常で使いやすい服でありながら、技術と思想の密度が非常に高いラインです。\n\nこのページでは、プリーツプリーズを“便利な服”としてだけでなく、三宅一生の人生、思想、ものづくり、身体観が日常に開かれたアーカイブとして読み解きます。",
      },
      brandOverview: {
        label: "03 / BRAND OVERVIEW",
        titleLines: [
          "三宅一生が目指したのは、",
          "一部の人だけの服ではなかった。",
        ],
        body:
          "三宅一生は、服を単なる流行や装飾ではなく、デザインとして考えた人物です。\n学生時代から衣服がデザインの領域として扱われるべきだと考え、パリやニューヨークで経験を積み、1970年に三宅デザイン事務所を設立しました。\n\n彼の根底にあったのは、“少数のためではなく、多くの人のための服”という考えです。\nPLEATS PLEASE ISSEY MIYAKEは、その思想が最も日常に近い形で実現したラインの一つです。",
        knowledgeItems: [
          {
            title: "服を、ファッションではなくデザインとして考えた。",
            text:
              "三宅一生の出発点には、衣服を流行の表面ではなく、人が使うデザインとして考える視点があります。だから彼の服は、見た目だけでなく、着ること、動くこと、洗うこと、畳むことまで含めて設計されています。",
          },
          {
            title: "“一枚の布”から身体と空間を考える。",
            text:
              "三宅一生の服作りには、布と身体、その間に生まれる空間を考える姿勢があります。PLEATS PLEASEも、身体に密着する服ではなく、プリーツによって伸び縮みしながら身体との距離を作ります。",
          },
          {
            title: "技術を、日常の自由へ変える。",
            text:
              "製品プリーツは高度な技術ですが、目的は難解な服を作ることではありません。軽く、扱いやすく、自由に着られる服を作るための技術です。",
          },
          {
            title: "アーカイブで評価される理由。",
            text:
              "PLEATS PLEASEは、古いシーズンでも古びにくいラインです。形が身体に適応し、色や柄の展開も多く、技術と日常性が両立しているため、過去のアイテムも価値を持ち続けます。",
          },
        ],
      },
      lineGuide: {
        label: "04 / WHY PLEATS PLEASE?",
        titleLines: [
          "なぜ三宅一生は、",
          "PLEATS PLEASEを作ったのか。",
        ],
        items: [
          {
            tag: "POINT 01",
            title: "多くの人が着られる服にするため",
            text:
              "PLEATS PLEASEは、身体を特定の形に押し込む服ではありません。プリーツが伸縮することで、さまざまな体型や動きに対応しやすくなります。三宅一生の“多くの人のための服”という思想と深くつながっています。",
          },
          {
            tag: "POINT 02",
            title: "服を生活の中で扱いやすくするため",
            text:
              "軽く、水洗いでき、乾きやすく、しわを気にしにくい。PLEATS PLEASEは、特別な日にだけ着る服ではなく、移動や旅行、日常生活の中で使える服として設計されています。",
          },
          {
            tag: "POINT 03",
            title: "身体の動きを美しく見せるため",
            text:
              "プリーツは静止した装飾ではありません。歩く、座る、腕を上げる、風を受ける。そのたびに服の表情が変わります。PLEATS PLEASEの美しさは、身体が動くことで完成します。",
          },
          {
            tag: "POINT 04",
            title: "技術を民主化するため",
            text:
              "高度な服作りを、一部の人だけのものにしない。PLEATS PLEASEは、複雑な技術を使いながら、日常で着られるプロダクトとして成立しています。ここに三宅一生らしいデザインの倫理があります。",
          },
        ],
      },
      firstExperience: {
        label: "05 / FIRST EXPERIENCE",
        titleLines: ["初めて着ると、", "何が分かるのか。"],
        intro:
          "PLEATS PLEASEの魅力は、写真だけでは分かりにくい服です。平置きでは平面的に見えても、身体に乗せた瞬間に、プリーツの伸縮、軽さ、揺れ、空間が立ち上がります。",
        items: [
          {
            index: "01",
            title: "軽さが、服への緊張をなくす",
            text:
              "PLEATS PLEASEは、見た目よりもずっと軽く感じることがあります。服に着られるのではなく、身体の動きに服がついてくる。この軽さが、日常で着る自由につながります。",
          },
          {
            index: "02",
            title: "プリーツが、身体に合わせて変化する",
            text:
              "プリーツは固定された装飾ではありません。身体の動きに合わせて開き、縮み、揺れます。サイズやシルエットを一つに固定せず、着る人の動きに応じて形が変わることが、PLEATS PLEASEの大きな特徴です。",
          },
          {
            index: "03",
            title: "平面と立体を行き来する",
            text:
              "PLEATS PLEASEの服は、畳むと平面的でコンパクトです。しかし着ると、身体の周囲に立体的な空間が生まれます。平面から立体へ変化する感覚は、三宅一生の服作りを体験するうえで重要です。",
          },
          {
            index: "04",
            title: "日常着なのに、アーカイブとして読める",
            text:
              "扱いやすい服でありながら、技術、思想、身体観が詰まっている。PLEATS PLEASEは、日常で着られるアーカイブです。だからレンタルで体験する意味があります。",
          },
        ],
      },
      quote: {
        textLines: [
          "プリーツは、身体を飾るためだけのものではない。",
          "身体が自由に動くための技術でもある。",
        ],
      },
      whyRent: {
        label: "06 / WHY RENT?",
        titleLines: [
          "PLEATS PLEASEほど、",
          "着て分かるラインは少ない。",
        ],
        items: [
          {
            number: "01",
            title: "写真だけでは軽さが分からない",
            text:
              "PLEATS PLEASEは、画像では色や柄が先に目に入ります。しかし実際に着ると、軽さ、伸縮、布の戻り方、動いたときの揺れが分かります。",
          },
          {
            number: "02",
            title: "サイズ感を体験しやすい",
            text:
              "プリーツの伸縮性があるため、一般的な服とはサイズの感じ方が異なります。レンタルで試すことで、自分の身体との距離を確認できます。",
          },
          {
            number: "03",
            title: "生活との相性を確認できる",
            text:
              "洗える、畳める、軽い、しわになりにくい。PLEATS PLEASEは生活との相性が非常に重要な服です。所有前に体験する意味があります。",
          },
          {
            number: "04",
            title: "買取前にも価値を理解しやすい",
            text:
              "所有しているPLEATS PLEASEを売る前に、ラインの背景や技術を知ることで、単なる古着ではなくアーカイブとしての価値を理解しやすくなります。",
          },
        ],
      },
      inventory: {
        label: "07 / AVAILABLE ARCHIVE",
        titleLines: ["Enclopediaで", "体験できるISSEY MIYAKE。"],
        body:
          "実在庫への導線は、“ブランド説明の続き”として設計します。PLEATS PLEASEの背景を知ったうえで、ISSEY MIYAKEのプリーツ、構造、素材、身体との距離を実際に体験へ進めます。",
        items: [
          {
            meta: "PLEATS PLEASE ISSEY MIYAKE",
            title: "レンタルできるPLEATS PLEASEを見る",
            text:
              "プリーツの軽さ、伸縮性、身体との距離を、実際に着ることで確かめる入口です。",
            href:
              "https://www.enclopedia-official.com/brand/PLEATS%20PLEASE（プリーツプリーズ）/?number=94",
          },
          {
            meta: "ISSEY MIYAKE",
            title: "レンタルできるISSEY MIYAKEを見る",
            text:
              "PLEATS PLEASEだけでなく、ISSEY MIYAKEの構造的な服やプリーツのアーカイブを確認できます。",
            href:
              "https://www.enclopedia-official.com/brand/ISSEY%20MIYAKE（イッセイミヤケ）/?number=29",
          },
          {
            meta: "SIGN UP",
            title: "Enclopediaに登録してアーカイブを体験する",
            text:
              "アーカイブファッションを、知る・読む・着る。会員登録すると、PLEATS PLEASEやISSEY MIYAKEのレンタル体験へ進めます。",
            href:
              "https://www.enclopedia-official.com/register",
          },
          {
            meta: "BUYBACK",
            title: "ISSEY MIYAKEの買取相談へ",
            text:
              "PLEATS PLEASE、ISSEY MIYAKE、HOMME PLISSÉ、me ISSEY MIYAKEなど、三宅一生のものづくりを背景に査定します。",
            href:
              "https://www.enclopedia-official.com/brand_buyback/issey-miyake",
          },
        ],
      },
      faq: {
        label: "08 / FAQ",
        titleLines: ["初めての人が、", "気になりやすいこと。"],
        items: [
          {
            question: "PLEATS PLEASE ISSEY MIYAKEはどんなブランドですか？",
            answer:
              "1988年に発表されたプリーツの研究を発展させ、1994年春夏から単独ブランドとして始まったラインです。縫製後にプリーツをかける製品プリーツによって、軽さ、着やすさ、水洗いできる扱いやすさを実現しています。",
          },
          {
            question: "普通のプリーツ服と何が違いますか？",
            answer:
              "一般的なプリーツは生地の装飾として見られがちですが、PLEATS PLEASEではプリーツが服の機能そのものになっています。伸縮し、動きに合わせて形が変わり、畳むとコンパクトで、着ると立体になります。",
          },
          {
            question: "なぜ三宅一生はこのラインを作ったのですか？",
            answer:
              "三宅一生が考えていた“多くの人のための服”を、日常で着られるプロダクトとして実現するためです。高度な技術を使いながら、軽く、扱いやすく、自由に着られる服としてPLEATS PLEASEが成立しています。",
          },
          {
            question: "PLEATS PLEASEはレンタルと相性がいいですか？",
            answer:
              "相性は非常に良いです。軽さ、伸縮性、身体との距離、動いたときの見え方は写真だけでは分かりにくいため、実際に着ることで理解が深まります。",
          },
          {
            question: "PLEATS PLEASEやISSEY MIYAKEの買取相談もできますか？",
            answer:
              "可能です。PLEATS PLEASE、ISSEY MIYAKE、HOMME PLISSÉ、me ISSEY MIYAKEなど、ライン、年代、状態、柄、プリーツの状態、現在の需要まで含めて確認します。",
          },
        ],
      },
      finalCta: {
        titleLines: [
          "PLEATS PLEASEを、",
          "レンタルから体験する。",
        ],
        body:
          "PLEATS PLEASE ISSEY MIYAKEは、三宅一生の思想と技術が、日常で最も体験しやすい形になったラインです。\nまずは背景を知り、実際に着て、軽さ、伸縮性、身体との距離を確かめてください。\nEnclopediaでは、レンタル、会員登録、買取相談まで一つの流れで案内します。",
        buttonLabel: "レンタルできるISSEY MIYAKEを見る",
        buttonHref:
          "https://www.enclopedia-official.com/brand/PLEATS%20PLEASE（プリーツプリーズ）/?number=94",
      },
    },
  };
  
  export default article;